// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/helpers.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("styles/img/icon_leave_note.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("styles/img/icon-important-active.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("styles/img/icon-important-inactive.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("styles/img/icon_close--gray.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__leaveNoteIcon___jDGLb {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: 24px;
  border-radius: 3px;
  box-shadow: none;
  cursor: pointer;
  display: inline-block;
  height: 40px;
  transition: background-color 0.25s;
  width: 40px;
}

.styles__leaveNoteIcon___jDGLb:hover {
    background-color: #e1dfe1;
  }

.styles__collapseIcon___sROR0 {
}

.styles__collapseRef___PvDYq {
}

.styles__collapseRef___PvDYq[data-active='true'] .styles__collapseIcon___sROR0 {
      transform: rotate(180deg);
    }

.styles__dropdownArea___qRBHY {
}

.styles__toggleLabel___bzDQv {
}

.styles__formItem___H69rF textarea {
    min-height: 100px;
  }

.styles__formItem___H69rF label {
    display: none;
  }

.styles__flexRow___Jz33m {
}

.styles__flexSB___FUzKA {
}

.styles__note___GtWAz {
  padding-bottom: 10px;
  font-weight: 500;
  white-space: pre-wrap;
}

.styles__notes___phn81 {
  list-style-type: none;
  margin: 0;
  overflow: auto;
  padding: 0;
}

.styles__noteWrapper___e8WyR {
  background: white;
  border-left: 4px solid gtYellow;
}

.styles__importantNoteWrapper___AtVmN {
  background: #fdf1ed;
}

.styles__importantNoteWrapper___AtVmN .styles__important___MDqFT {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }

.styles__important___MDqFT,
.styles__remove___iIeQO,
.styles__user___mJpeH {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
  font-size: 12px;
}

.styles__title___zQjsK {
  flex: 1;
}

.styles__titleSection___ghd7b {
  /* position: relative; */
}

.styles__titleSection___ghd7b:last-child {
    margin-bottom: 20px;
  }

.styles__titleSection___ghd7b .styles__name___Cef5m {
    transition: all 0.25s;
  }

.styles__titleSection___ghd7b .styles__noName___HakI1 {
    margin-top: 2px;
  }

.styles__user___mJpeH {
  text-transform: capitalize;
}

.styles__important___MDqFT {
  margin-right: 15px;
  background-position: center;
  background-size: 13px;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  cursor: pointer;
}

.styles__important___MDqFT a {
    display: block;
    box-shadow: none;
    height: 20px;
    width: 20px;
  }

.styles__remove___iIeQO {
  margin-left: 4px;
  background-position: center;
  background-size: 11px;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  cursor: pointer;
}

.styles__remove___iIeQO a {
    display: block;
    box-shadow: none;
    height: 100%;
    width: 24px;
  }

.styles__buttons___hjOZ4 {
  display: flex;
  justify-content: flex-end;
}

.styles__removeBtn___io7mC {
}

.styles__cancelBtn___mNFzW {
  margin-left: 14px;
}
`, "",{"version":3,"sources":["webpack://./universal/components/Notes/styles.css"],"names":[],"mappings":"AAIA;EACE,yDAAuD;EACvD,2BAA2B;EAC3B,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,kCAAkC;EAClC,WAAW;AAKb;;AAHE;IACE,yBAAyB;EAC3B;;AAGF;AAEA;;AAEA;AAQA;;AAJI;MACE,yBAAyB;IAC3B;;AAIJ;AAEA;;AAEA;AAEA;;AAGE;IACE,iBAAiB;EACnB;;AAEA;IACE,aAAa;EACf;;AAGF;AAEA;;AAEA;AAEA;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;AAEjC;;AAEA;EACE,mBAAmB;AAKrB;;AAHE;IACE,yDAA6D;EAC/D;;AAGF;;;EAGE,mDAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,OAAO;AACT;;AAEA;EAEE,wBAAwB;AAa1B;;AAXE;IACE,mBAAmB;EACrB;;AAEA;IACE,qBAAqB;EACvB;;AAEA;IACE,eAAe;EACjB;;AAGF;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,qBAAqB;EACrB,4BAA4B;EAC5B,yDAA+D;EAC/D,eAAe;AAQjB;;AANE;IACE,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,WAAW;EACb;;AAGF;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,qBAAqB;EACrB,4BAA4B;EAC5B,yDAAwD;EACxD,eAAe;AAQjB;;AANE;IACE,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,WAAW;EACb;;AAGF;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;AAEA;;AAEA;EAEE,iBAAiB;AACnB","sourcesContent":["@value helpers: 'styles/helpers.css';\n@value colors: \"styles/colors.css\";\n@value gtRed, gtGray, textLight from colors;\n\n.leaveNoteIcon {\n  background-image: url('styles/img/icon_leave_note.png');\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: 24px;\n  border-radius: 3px;\n  box-shadow: none;\n  cursor: pointer;\n  display: inline-block;\n  height: 40px;\n  transition: background-color 0.25s;\n  width: 40px;\n\n  &:hover {\n    background-color: #e1dfe1;\n  }\n}\n\n.collapseIcon {\n  composes: collapseIcon from helpers;\n}\n\n.collapseRef {\n  composes: collapseRef from helpers;\n\n  &[data-active='true'] {\n    .collapseIcon {\n      transform: rotate(180deg);\n    }\n  }\n}\n\n.dropdownArea {\n  composes: dropdownArea from helpers;\n}\n\n.toggleLabel {\n  composes: toggleLabel from helpers;\n}\n\n.formItem {\n  textarea {\n    min-height: 100px;\n  }\n\n  label {\n    display: none;\n  }\n}\n\n.flexRow {\n  composes: flexRow from helpers;\n}\n\n.flexSB {\n  composes: flexSB from helpers;\n}\n\n.note {\n  padding-bottom: 10px;\n  font-weight: 500;\n  white-space: pre-wrap;\n}\n\n.notes {\n  list-style-type: none;\n  margin: 0;\n  overflow: auto;\n  padding: 0;\n}\n\n.noteWrapper {\n  background: white;\n  border-left: 4px solid gtYellow;\n  composes: noteWrapper from helpers;\n}\n\n.importantNoteWrapper {\n  background: #fdf1ed;\n\n  .important {\n    background-image: url('styles/img/icon-important-active.png');\n  }\n}\n\n.important,\n.remove,\n.user {\n  color: textLight;\n  font-size: 12px;\n}\n\n.title {\n  flex: 1;\n}\n\n.titleSection {\n  composes: sectionTitle row from helpers;\n  /* position: relative; */\n\n  &:last-child {\n    margin-bottom: 20px;\n  }\n\n  .name {\n    transition: all 0.25s;\n  }\n\n  .noName {\n    margin-top: 2px;\n  }\n}\n\n.user {\n  text-transform: capitalize;\n}\n\n.important {\n  margin-right: 15px;\n  background-position: center;\n  background-size: 13px;\n  background-repeat: no-repeat;\n  background-image: url('styles/img/icon-important-inactive.png');\n  cursor: pointer;\n\n  a {\n    display: block;\n    box-shadow: none;\n    height: 20px;\n    width: 20px;\n  }\n}\n\n.remove {\n  margin-left: 4px;\n  background-position: center;\n  background-size: 11px;\n  background-repeat: no-repeat;\n  background-image: url('styles/img/icon_close--gray.png');\n  cursor: pointer;\n\n  a {\n    display: block;\n    box-shadow: none;\n    height: 100%;\n    width: 24px;\n  }\n}\n\n.buttons {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.removeBtn {\n  composes: buttonDanger from helpers;\n}\n\n.cancelBtn {\n  composes: button from helpers;\n  margin-left: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `'styles/helpers.css'`,
	"colors": `"styles/colors.css"`,
	"gtRed": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]}`,
	"gtGray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]}`,
	"textLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]}`,
	"leaveNoteIcon": `styles__leaveNoteIcon___jDGLb`,
	"collapseIcon": `styles__collapseIcon___sROR0 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["collapseIcon"]}`,
	"collapseRef": `styles__collapseRef___PvDYq ${___CSS_LOADER_ICSS_IMPORT_1___.locals["collapseRef"]}`,
	"dropdownArea": `styles__dropdownArea___qRBHY ${___CSS_LOADER_ICSS_IMPORT_1___.locals["dropdownArea"]}`,
	"toggleLabel": `styles__toggleLabel___bzDQv ${___CSS_LOADER_ICSS_IMPORT_1___.locals["toggleLabel"]}`,
	"formItem": `styles__formItem___H69rF`,
	"flexRow": `styles__flexRow___Jz33m ${___CSS_LOADER_ICSS_IMPORT_1___.locals["flexRow"]}`,
	"flexSB": `styles__flexSB___FUzKA ${___CSS_LOADER_ICSS_IMPORT_1___.locals["flexSB"]}`,
	"note": `styles__note___GtWAz`,
	"notes": `styles__notes___phn81`,
	"noteWrapper": `styles__noteWrapper___e8WyR ${___CSS_LOADER_ICSS_IMPORT_1___.locals["noteWrapper"]}`,
	"importantNoteWrapper": `styles__importantNoteWrapper___AtVmN`,
	"important": `styles__important___MDqFT`,
	"remove": `styles__remove___iIeQO`,
	"user": `styles__user___mJpeH`,
	"title": `styles__title___zQjsK`,
	"titleSection": `styles__titleSection___ghd7b ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionTitle"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["row"]}`,
	"name": `styles__name___Cef5m`,
	"noName": `styles__noName___HakI1`,
	"buttons": `styles__buttons___hjOZ4`,
	"removeBtn": `styles__removeBtn___io7mC ${___CSS_LOADER_ICSS_IMPORT_1___.locals["buttonDanger"]}`,
	"cancelBtn": `styles__cancelBtn___mNFzW ${___CSS_LOADER_ICSS_IMPORT_1___.locals["button"]}`
};
export default ___CSS_LOADER_EXPORT___;
